module.exports = __webpack_public_path__ + "img/records-completed-en.9422dbfa.png";